module.exports = __webpack_public_path__ + "static/media/13-steph-engagement-09_06_2020.3fd00bd1.jpg";